module.exports = __webpack_public_path__ + "static/media/img.6a75ae3c.png";